import { useEffect } from 'react';

/**
 * Discourages casual saving of displayed photos: blocks the context menu,
 * drag-to-desktop and the iOS long-press "Save Image" sheet.
 *
 * This is a deterrent, not a protection. Anyone who opens the network tab can
 * still fetch what the browser fetched. The actual safeguard is server-side:
 * viewers who have not bought a photo are served a watermarked copy.
 */
export const useImageProtection = () => {
  useEffect(() => {
    const isProtectedImage = (target) => (
      target instanceof HTMLImageElement && !target.dataset.allowSave
    );

    const blockContextMenu = (event) => {
      if (isProtectedImage(event.target)) event.preventDefault();
    };

    const blockDrag = (event) => {
      if (isProtectedImage(event.target)) event.preventDefault();
    };

    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('dragstart', blockDrag);

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('dragstart', blockDrag);
    };
  }, []);
};
